module.exports = __webpack_public_path__ + "assets/img/title-4af1c34b.png";